module.exports = __webpack_public_path__ + "img/gntb_xzxj.f7b30ad7.png";